export default __webpack_public_path__ + "static/media/Fox.5c677518.svg";